// extracted by mini-css-extract-plugin
module.exports = {"productGrid":"Ce","centerLink":"De","productSection":"Ee","item":"Fe","ctaButton":"Ge"};